import { generateDescriptionMarkup } from './markup-utils';

export function getQuadZoomConfig() {
	return t => ({
		popoverClass: 'ramsoft-tutorial-popover',
		animate: true,
		nextBtnText: 'show me',
		doneBtnText: 'done',
		showProgress: false,
		allowKeyboardControl: false,
		showButtons: ['next'],
		onPopoverRender: (popover, { state }) => {
			const { activeIndex } = state;
			const isFirstStep = activeIndex === 0;
			if (isFirstStep) {
				const skipButton = document.createElement('button');
				skipButton.innerText = 'SKIP';
				skipButton.classList.add('text-btn');
				popover.footerButtons.prepend(skipButton);

				skipButton.addEventListener('click', () => {
					popover.closeButton?.click();
				});
			}
		},
		steps: [
			{
				stepNum: 1,
				element: '[data-tut="mg-viewport"]',
				popover: {
					description: generateDescriptionMarkup(
						() => `
							<p>${t('quadZoom.meet')}</p>
						`
					),
					side: 'left',
					align: 'end',
				},
			},
			{
				stepNum: 2,
				element: '[data-tut="mg-viewport"]',
				popover: {
					description: generateDescriptionMarkup(
						() => `
							<ul>
								<li>${t('quadZoom.clickToActivate')}</li>
								<li>${t('quadZoom.navigate')}</li>
								<li>${t('quadZoom.forRight')}</li>
								<li>${t('quadZoom.forLeft')}</li>
								<li>${t('quadZoom.escape')}</li>
							</ul>
						`
					),
					side: 'left',
					align: 'end',
				},
			},
		],
	});
}
